// routes
import Router from './routes';
// theme
import ThemeProvider from './theme';
// components
import ThemeSettings from './components/settings';
// import { ChartStyle } from './components/chart';
import MotionLazyContainer from './components/animate/MotionLazyContainer';
import AuthDialogContainer from './components/AuthDialogContainer';
import CustomConfirm from './components/CustomConfirm';
import LoadingScreen from './components/LoadingScreen';
import NotistackProvider from './components/NotistackProvider';
import { ProgressBarStyle } from './components/ProgressBar';
import ScrollToTop from './components/ScrollToTop';
import TawkChat from './components/TawktChat';

// ----------------------------------------------------------------------

export default function App() {
  return (
    <MotionLazyContainer>
      <ThemeProvider>
        <ThemeSettings>
          <NotistackProvider>
            <ProgressBarStyle />
            {/* <ChartStyle /> */}

            <ScrollToTop />
            <Router />
            <AuthDialogContainer />
            <CustomConfirm />
            <LoadingScreen />
            <TawkChat />
          </NotistackProvider>
        </ThemeSettings>
      </ThemeProvider>
    </MotionLazyContainer>
  );
}
